import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';
import {PANEL, WEB_SETTINGS} from '../../../constants/appUrls.constants';
import {isWebSettingsAllowed} from '../../templates/Web/WebSettings/allowedEmails';

// Dashboard'larin sol menusunde, logonun ustunde duran Panel + Site Ayarlari girisi.
// Menu ogeleriyle ayni gorsel dil: ikon solda, metin sagda, yuvarlak kose.
const useStyles = makeStyles(() => ({
    wrapper: {
        flex: '0 0 auto',
        marginTop: 'auto',
        padding: '10px 4px 10px',
        borderTop: '1px solid #e2e8f0',
    },
    // Mobil: kart icinde, mevcut aksiyonlarin devami olarak
    wrapperInline: {
        marginTop: 16,
        paddingTop: 16,
        borderTop: '1px solid #e2e8f0',
    },
    stack: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    action: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        padding: '20px 14px',
        borderRadius: 16,
        background: '#f1f5f9',
        color: '#475569',
        textDecoration: 'none',
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1.2,
        transition: 'background 0.2s ease, color 0.2s ease',
        '& i': {
            width: 20,
            fontSize: 16,
            textAlign: 'center',
            flexShrink: 0,
            color: '#64748b',
            transition: 'color 0.2s ease',
        },
        '&:hover': {
            background: '#e6ebf2',
            color: '#1e293b',
            '& i': {
                color: '#d71f26',
            },
        },
        '&:focus': {
            outline: 'none',
        },
    },
}));

export default function DashboardBottomActions({inline}) {
    const {t} = useTranslation();
    const classes = useStyles();

    const userEmail = useSelector((state) => state.profileReducer
        && state.profileReducer.profileData
        && state.profileReducer.profileData.profile
        && state.profileReducer.profileData.profile.email);

    // Burada getProfile cagrilmaz: dashboard'larin Sidebar'i render() icinde
    // tanimli oldugu icin her render'da yeni bilesen tipi olusuyor ve bu agac
    // komple remount ediliyor. Mount'ta dispatch etmek sonsuz donguye yol aciyordu.
    // Profili sayfanin kendisi cekiyor (componentDidMount).

    // Kademeli acilis: yalnizca izinli hesaplara gorunur
    if (!isWebSettingsAllowed(userEmail)) return null;

    return (
        <Box className={inline ? classes.wrapperInline : classes.wrapper}>
            <div className={classes.stack}>
                <Link to={PANEL} className={classes.action}>
                    <i className="fas fa-chart-pie" />
                    {t('enw-panel-page_title', 'Panel')}
                </Link>
                <Link to={WEB_SETTINGS} className={classes.action}>
                    <i className="fas fa-cog" />
                    {t('enw-web-settings-page_title', 'Site Ayarları')}
                </Link>
            </div>
        </Box>
    );
}
